<template>
  <div class="sale-area">
    <div class="row">
      <div class="col-md-3">
        <div class="lead-search sourceby">
          <div
            class="form-group"
            v-if="
              this.$storage.get('auth').user.user_type == 1 ||
              this.$storage.get('auth').user.permissions.indexOf('8') != -1
            "
          >
            <label>Agents</label>
            <SingleSelect
              v-on:change="getLeadsCounts('update_graph')"
              :searchable="true"
              id="a_usersads"
              textColumn="text"
              :alreadySelected="agent"
              placeholder="Select Agent"
              v-model="agent"
              :options="allEmployees"
            ></SingleSelect>
            <!-- <select class="form-control" id="by" v-model="filterSearch.by">
                        <option value="">Select Value</option>
                        <option v-for="source in LSources" :value="source.ls_id" :key="source.ls_id" >{{source.ls_name}}</option>
                    </select> -->
          </div>
        </div>
        <!-- <div  class="lead-search sourceby" >
                <div style="position: relative;bottom: 50px;">
                    <span>By</span>
                    <multi-select :searchable="true"  id="a_users" textColumn="text" placeholder="Select sources" v-model="filterSearch.by" :options="LSources" ></multi-select>
                </div>
            </div> -->
      </div>

      <div class="col-md-9">
        <div class="sale-timeline">
          <div class="timeline">
            <router-link
              :to="{ path: '/my-reports' }"
              class="my-reports-btn"
              v-if="
                $route.name != 'myReports' &&
                $storage.get('auth').user.user_type != 2
              "
              >My Reports</router-link
            >
            <button
              type="button"
              v-bind:class="filters_.duration == 'today' ? 'current' : ''"
              v-on:click="updateGraphs('today')"
            >
              <span class="today">Today</span>
            </button>
            <button
              type="button"
              v-bind:class="filters_.duration == 'monthly' ? 'current' : ''"
              v-on:click="updateGraphs('monthly')"
            >
              <span class="today">This Month</span>
            </button>
            <button
              type="button"
              v-bind:class="filters_.duration == 'custom' ? 'current' : ''"
            >
              <date-range-picker
                :opens="'left'"
                :ranges="false"
                :locale-data="{ format: 'yyyy-mm-dd' }"
                v-model="filters_.customDate"
                @update="updateGraphs('custom')"
              >
              </date-range-picker>
              <span class="month">Custom Date</span>
            </button>
          </div>
        </div>
      </div>

      <!-- lead-search -->
      <!-- <div class="col-12" v-if="$route.name != 'myReports' && $storage.get('auth').user.user_type != 2">
                <div class="row">
                    <div class="col-md-3">
                        <div class="select-option">
                            <div class="form-group">
                                <select class="form-control" v-model="filters_.id" v-on:change="getLeadsCounts('update_graph')">
                                    <option value="0">Select Agent</option>
                                    <option v-for="emp in allEmployees" :key="emp.id" :value="emp.id">{{emp.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-9">
                        <button class="rem-btn pull-right" v-on:click="$router.push('/my-reports')">My Reports</button>
                    </div>
                </div>
            </div> -->
      <!-- lead-search -->

      <div class="col-12">
        <!-- total-heading -->
        <div class="total-heading">
          <router-link
            :to="{
              name: 'appointments',
              query: { duration: 'today', status: 'pending' },
            }"
            class="totalheading-box"
          >
            <div class="media">
              <img
                src="../../assets/img/app-icon.svg"
                class="mr-3 img-fluid"
                alt="..."
              />
              <div class="media-body">
                <h5
                  style="color: #343945; font-weight: 600; font-size: 18px"
                  class="mt-0"
                >
                  Today’s Appointments
                </h5>
                <h3>{{ todayStats.appt }}</h3>
              </div>
            </div>
          </router-link>
          <router-link
            :to="{ name: 'tasks', query: { duration: 'today', type: 0 } }"
            class="totalheading-box"
          >
            <div class="media">
              <img
                src="../../assets/img/cicon.svg"
                class="mr-3 img-fluid"
                alt="..."
              />
              <div class="media-body">
                <h5
                  style="color: #343945; font-weight: 600; font-size: 18px"
                  class="mt-0"
                >
                  Today’s Tasks
                </h5>
                <h3>{{ todayStats.tasks }}</h3>
              </div>
            </div>
          </router-link>
          <router-link
            :to="{
              name: 'alerts',
              query: { duration: 'today', status: 'pending' },
            }"
            class="totalheading-box"
          >
            <div class="media">
              <img
                src="../../assets/img/erro.svg"
                class="mr-3 img-fluid"
                alt="..."
              />
              <div class="media-body">
                <h5
                  style="color: #343945; font-weight: 600; font-size: 18px"
                  class="mt-0"
                >
                  Today’s Alerts
                </h5>
                <h3>{{ todayStats.alerts }}</h3>
              </div>
            </div>
          </router-link>
          <router-link
            :to="{
              name: 'Leads',
              query: { type: 'untouched', duration: 'today' },
            }"
            class="totalheading-box"
          >
            <div class="media">
              <img
                src="../../assets/img/leg.svg"
                class="mr-3 img-fluid"
                alt="..."
              />
              <div class="media-body">
                <h5
                  style="color: #343945; font-weight: 600; font-size: 18px"
                  class="mt-0"
                >
                  Untouched Internet Leads
                </h5>
                <h3>{{ todayStats.leads }}</h3>
              </div>
            </div>
          </router-link>
        </div>
        <!-- total-heading -->
      </div>

      <!-- <div class="col-12 perfor-search" v-if="$route.name != 'myReports' && $storage.get('auth').user.user_type != 2">
                <div class="form-row">
                    <div class="form-group col-md-5">
                        <autocomplete
                            ref="autocomplete"
                            placeholder="Search by Agent or Team"
                            input-class="form-control"
                            :source="base_url+'search_agent_or_team/'"
                            results-property="data"
                            :results-display=formattedAutocompleteDisplay
                            :request-headers="autocompleteAuthHeaders"
                            @selected="getLeadsCounts">
                        </autocomplete>
                    </div>
                    <div class="form-group col-md-7">
                        <button class="rem-btn pull-right" v-on:click="$router.push('/my-reports')">My Reports</button>
                    </div>
                </div>
            </div> -->

      <div class="col-md-6 col-lg-8">
        <div class="active-tabss sale-active">
          <div class="tl">
            <ul class="tl_btns">
              <li @click="goToLeadsheet(1)" class="active original-active">
                <a>
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="19"
                      viewBox="0 0 27 19"
                      fill="none"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                          d="M1.44727 10.2649L8.85779 17.6402L25.5315 1.0459"
                          stroke="#A2A8B8"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect
                            x="0.773438"
                            y="0.0400391"
                            width="25.6"
                            height="18.7733"
                            fill="white"
                          />
                        </clipPath>
                      </defs></svg
                  ></span>
                  <p>Active</p>
                  <h5>{{ leadsCounts[1] }}</h5>
                  <img
                    class="img-fluid"
                    src="../../assets/img/shadow.svg"
                    alt=""
                  />
                </a>
              </li>
              <li>
                <a @click="goToLeadsheet(2)">
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="25"
                      viewBox="0 0 40 25"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M26.2036 1.3987C25.354 0.877949 24.3506 0.642932 23.3563 0.753339L23.356 0.753371L21.1313 0.997843L21.1281 0.998207C19.9502 1.13517 18.8645 1.72393 18.12 2.65911L13.8321 7.82648L13.8317 7.82698C13.3803 8.36935 13.5568 9.20892 14.2175 9.5067C15.989 10.3174 18.0567 10.0731 19.5962 8.88474L19.5962 8.88468L21.7972 7.18507L21.7973 7.18519L21.8069 7.17739C21.8074 7.17694 21.8075 7.17693 21.8079 7.1768C21.8085 7.17659 21.8108 7.17596 21.815 7.17606C21.8241 7.1763 21.8369 7.17994 21.8488 7.18962L21.8511 7.19146L22.7192 7.88842C22.9345 8.06129 23.2492 8.02687 23.4221 7.81154C23.595 7.5962 23.5606 7.2815 23.3452 7.10862L22.4794 6.4135L22.478 6.41241C22.1177 6.12068 21.5771 6.08017 21.1819 6.39675L18.9851 8.09315L18.985 8.0932C17.7371 9.05647 16.064 9.25255 14.6323 8.59682L14.6286 8.59515C14.582 8.57426 14.5637 8.51064 14.6004 8.46667L14.601 8.46586L18.8929 3.29366L18.8929 3.29374L18.8996 3.28532C19.4752 2.56048 20.3193 2.09939 21.2421 1.99169L21.2436 1.99151L23.4659 1.74732L23.4665 1.74725C24.2313 1.66227 25.0114 1.84209 25.677 2.24883L30.6758 5.44898L30.6758 5.45657V17.684C30.6758 18.6326 31.4499 19.4067 32.3985 19.4067H38.8791C39.1552 19.4067 39.3791 19.1829 39.3791 18.9067V4.23383C39.3791 3.95769 39.1552 3.73383 38.8791 3.73383H32.3985C31.8189 3.73383 31.3045 4.0228 30.9919 4.464L26.2119 1.4039L26.212 1.40382L26.2036 1.3987ZM14.9684 4.38495C15.2072 4.24626 15.2883 3.94025 15.1496 3.70146C15.011 3.46268 14.7049 3.38153 14.4662 3.52022L12.1616 4.85874H10.6211C10.345 4.85874 10.1211 5.08259 10.1211 5.35874C10.1211 5.63488 10.345 5.85874 10.6211 5.85874H12.2963C12.3845 5.85874 12.4711 5.8354 12.5474 5.7911L14.9684 4.38495ZM0.558105 3.73383C0.281963 3.73383 0.0581055 3.95769 0.0581055 4.23383V18.9067C0.0581055 19.1829 0.281963 19.4067 0.558105 19.4067H7.03864C7.98729 19.4067 8.76138 18.6326 8.76138 17.684V17.4014H10.3396L13.7151 22.9687L13.716 22.9702C14.4795 24.2196 15.8396 24.9824 17.3095 24.9824C18.1632 24.9824 18.7902 24.3435 18.9037 23.609C19.379 23.7442 19.8429 23.7969 20.2924 23.7578C21.0052 23.6959 21.6448 23.406 22.2008 22.9138C22.4272 22.7161 22.578 22.4658 22.6562 22.1968C23.1533 22.3455 23.6382 22.4047 24.1073 22.3639C24.8201 22.3019 25.4598 22.0121 26.0158 21.5199C26.1935 21.3646 26.3247 21.1769 26.4107 20.9732C27.4407 21.14 28.3705 20.8748 29.1603 20.1607C29.7317 19.6595 29.8193 18.8229 29.4729 18.1992L29.4729 18.1992L29.4694 18.1931L28.3811 16.2978C28.2436 16.0584 27.938 15.9757 27.6986 16.1132C27.4591 16.2507 27.3764 16.5563 27.5139 16.7958L28.6002 18.6875C28.7401 18.9423 28.6821 19.2511 28.4995 19.41L28.4995 19.41L28.4922 19.4166C27.9249 19.9307 27.2779 20.122 26.4909 19.9723C26.4569 19.8277 26.4033 19.6874 26.3306 19.5565L26.3306 19.5565L26.3274 19.5508L24.1142 15.687C23.977 15.4474 23.6715 15.3644 23.4319 15.5016C23.1922 15.6389 23.1092 15.9444 23.2465 16.184L25.4578 20.0446C25.5023 20.1256 25.5268 20.212 25.5337 20.2974C25.5268 20.3412 25.526 20.3849 25.5306 20.4275C25.5131 20.5621 25.4519 20.6849 25.3573 20.7673L25.3573 20.7673L25.3541 20.7701C24.9444 21.1331 24.5025 21.3258 24.0207 21.3677C23.6041 21.4039 23.1313 21.3295 22.5965 21.1184C22.5729 21.061 22.5459 21.0049 22.5157 20.9505L22.5157 20.9504L22.5125 20.9448L20.2993 17.0809C20.162 16.8413 19.8565 16.7583 19.6169 16.8955C19.3773 17.0328 19.2943 17.3383 19.4316 17.5779L21.6081 21.3779C21.5874 21.5198 21.6292 21.6634 21.72 21.7717C21.7126 21.9255 21.6486 22.0687 21.5423 22.1613L21.5423 22.1612L21.5391 22.1641C21.1295 22.527 20.6876 22.7197 20.2057 22.7616C19.7545 22.8008 19.2374 22.7102 18.6468 22.4568L16.6 18.669C16.4687 18.4261 16.1654 18.3356 15.9224 18.4668C15.6795 18.5981 15.589 18.9015 15.7203 19.1444L17.8478 23.0817L17.8477 23.0817L17.8536 23.092C17.9008 23.1746 17.9222 23.2692 17.9222 23.3697C17.9222 23.69 17.6602 23.9824 17.3095 23.9824C16.1875 23.9824 15.1513 23.4006 14.5697 22.4495L14.5693 22.4487L11.0487 16.6422C10.958 16.4927 10.7959 16.4014 10.6211 16.4014H8.76138V5.45657C8.76138 4.50792 7.98729 3.73383 7.03864 3.73383H0.558105ZM7.76123 16.9014L7.76138 16.8891V5.45657C7.76138 5.06021 7.435 4.73383 7.03864 4.73383H1.05811V18.4067H7.03864C7.435 18.4067 7.76138 18.0804 7.76138 17.684V16.9138L7.76123 16.9014ZM4.74 14.9328C4.74 15.2975 4.44438 15.5931 4.07971 15.5931C3.71505 15.5931 3.41943 15.2975 3.41943 14.9328C3.41943 14.5681 3.71505 14.2725 4.07971 14.2725C4.44438 14.2725 4.74 14.5681 4.74 14.9328ZM32.3985 4.73383C32.0022 4.73383 31.6758 5.06021 31.6758 5.45657V17.684C31.6758 18.0804 32.0022 18.4067 32.3985 18.4067H38.3791V4.73383H32.3985ZM36.0173 14.9328C36.0173 15.2975 35.7217 15.5931 35.3571 15.5931C34.9924 15.5931 34.6968 15.2975 34.6968 14.9328C34.6968 14.5681 34.9924 14.2725 35.3571 14.2725C35.7217 14.2725 36.0173 14.5681 36.0173 14.9328ZM27.214 15.5931C27.5786 15.5931 27.8743 15.2975 27.8743 14.9328C27.8743 14.5681 27.5786 14.2725 27.214 14.2725C26.8493 14.2725 26.5537 14.5681 26.5537 14.9328C26.5537 15.2975 26.8493 15.5931 27.214 15.5931ZM24.0863 8.65003C24.335 8.52996 24.6339 8.6342 24.754 8.88287L26.6492 12.8079C26.7693 13.0565 26.665 13.3555 26.4164 13.4755C26.1677 13.5956 25.8688 13.4914 25.7487 13.2427L23.8535 9.3177C23.7334 9.06903 23.8376 8.77011 24.0863 8.65003Z"
                        fill="#A2A8B8"
                      /></svg
                  ></span>
                  <p>Contacted</p>
                  <h5>{{ leadsCounts[2] }}</h5>
                  <img
                    class="img-fluid"
                    src="../../assets/img/shadow.svg"
                    alt=""
                  />
                </a>
              </li>
              <li>
                <a @click="goToLeadsheet(3)">
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="31"
                      viewBox="0 0 30 31"
                      fill="none"
                    >
                      <path
                        d="M15.8407 27.9259H2.55906C1.94573 27.9259 1.44873 27.4196 1.44873 26.795V4.55382C1.44873 3.92913 1.94573 3.42291 2.55906 3.42291H26.3518C26.9651 3.42291 27.4621 3.92913 27.4621 4.55382V16.9076"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M20.8213 0.751831V5.06004"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.4621 8.40967H1.44873"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.95687 17.1015H5.25578C4.95969 17.1015 4.72705 16.8646 4.72705 16.563V14.3227C4.72705 14.0211 4.95969 13.7842 5.25578 13.7842H8.95687C9.25295 13.7842 9.48559 14.0211 9.48559 14.3227V16.563C9.48559 16.8538 9.25295 17.1015 8.95687 17.1015Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.306 17.1015H12.6049C12.3088 17.1015 12.0762 16.8646 12.0762 16.563V14.3227C12.0762 14.0211 12.3088 13.7842 12.6049 13.7842H16.306C16.6021 13.7842 16.8347 14.0211 16.8347 14.3227V16.563C16.8347 16.8538 16.6021 17.1015 16.306 17.1015Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M19.4253 16.1752V14.3227C19.4253 14.0211 19.6579 13.7842 19.954 13.7842H23.6445C23.9406 13.7842 24.1733 14.0211 24.1733 14.3227V15.5398"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.95687 23.6931H5.25578C4.95969 23.6931 4.72705 23.4561 4.72705 23.1545V20.9143C4.72705 20.6127 4.95969 20.3757 5.25578 20.3757H8.95687C9.25295 20.3757 9.48559 20.6127 9.48559 20.9143V23.1545C9.48559 23.4453 9.25295 23.6931 8.95687 23.6931Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.6881 23.6931H12.6049C12.3194 23.6931 12.0762 23.4561 12.0762 23.1545V20.9143C12.0762 20.6235 12.3194 20.3757 12.6049 20.3757H15.3649"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M28.403 22.3683C28.4981 22.7883 28.551 23.2407 28.551 23.693C28.551 26.9242 25.9814 29.5414 22.8196 29.5414C19.6472 29.5414 17.0776 26.9242 17.0776 23.693C17.0776 20.4726 19.6472 17.8554 22.8196 17.8554C23.9617 17.8554 25.0297 18.2001 25.9285 18.8032"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21.1489 23.5207L22.714 25.1148L28.5511 19.1694"
                        fill="white"
                      />
                      <path
                        d="M21.1489 23.5207L22.714 25.1148L28.5511 19.1694"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.5293 0.751831V5.06004"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /></svg
                  ></span>
                  <p>Scheduled</p>
                  <h5>{{ leadsCounts[3] }}</h5>
                  <img
                    class="img-fluid"
                    src="../../assets/img/shadow.svg"
                    alt=""
                  />
                </a>
              </li>
              <li class="vvv">
                <a @click="goToLeadsheet(4)">
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="34"
                      height="47"
                      viewBox="0 0 34 47"
                      fill="none"
                    >
                      <path
                        d="M18.3125 9.40841C20.595 9.40841 22.4454 7.52612 22.4454 5.2042C22.4454 2.88229 20.595 1 18.3125 1C16.03 1 14.1797 2.88229 14.1797 5.2042C14.1797 7.52612 16.03 9.40841 18.3125 9.40841Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M16.6154 10.9098C12.4678 11.9008 8.54894 13.1696 5.84783 14.3633C5.35337 14.581 4.94746 14.9639 4.70392 15.4519L1.16886 22.5465C0.807241 23.2747 1.0434 24.1606 1.71499 24.596C2.49728 25.1065 3.53787 24.8062 3.95115 23.9579L7.16886 17.2912L11.6264 15.8498C11.7297 15.8198 11.8405 15.8198 11.929 15.8648C12.0914 15.9474 12.1726 16.1201 12.143 16.2927L8.822 34.8813C8.75558 35.2567 8.59322 35.6095 8.35706 35.9098L2.9327 42.6516C2.42348 43.2822 2.3792 44.1831 2.82938 44.8588C3.49359 45.8723 4.92532 45.9774 5.72237 45.0615L11.8035 38.087C12.1061 37.7417 12.298 37.3137 12.3497 36.8558L13.0286 31.06C13.0803 30.5945 13.619 30.3768 13.9733 30.6771L18.1947 34.2582C18.6523 34.6411 18.9327 35.1966 18.9844 35.7972L19.6928 44.063C19.7814 45.1216 20.7556 45.8648 21.7814 45.6621C22.6301 45.4894 23.2353 44.7161 23.1984 43.8378L22.7777 34.2207C22.7556 33.6201 22.4973 33.0495 22.0619 32.6366C22.0619 32.6366 16.3423 28.1996 16.8441 27.569C18.3202 25.6921 18.7334 19.6336 18.7334 19.6336C18.8294 19.2657 19.3091 19.1831 19.5157 19.4984L21.8847 22.9969C22.2464 23.5225 22.8072 23.8753 23.4272 23.9579L31.0139 24.9489C31.9142 25.069 32.7039 24.3558 32.7039 23.4324C32.7039 22.6966 32.1873 22.066 31.4788 21.9309L24.6523 20.6396C24.1283 20.542 23.6633 20.2116 23.4124 19.7387C21.191 15.4894 19.1246 10.3092 16.6154 10.9098Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                      /></svg
                  ></span>
                  <p>Visit</p>
                  <h5>{{ leadsCounts[4] }}</h5>
                  <img
                    class="img-fluid"
                    src="../../assets/img/shadow.svg"
                    alt=""
                  />
                </a>
              </li>
              <li>
                <a @click="goToLeadsheet(5)">
                  <span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="37"
                      height="35"
                      viewBox="0 0 37 35"
                      fill="none"
                    >
                      <path
                        d="M8.66294 21.1944L5.53809 24.4386"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3.94727 21.1944H8.65148H17.2138C18.0712 21.1944 18.7819 21.9077 18.7819 22.805V23.6908C18.7819 24.5652 18.0825 25.2899 17.2138 25.2899H13.7957"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.796 25.3013H18.974C19.3011 25.3013 19.617 25.2093 19.8878 25.0367L24.4453 22.1261C25.235 21.62 26.2841 21.85 26.8031 22.6438C27.3333 23.4721 27.1077 24.5766 26.2841 25.1058L20.779 28.6261C20.5082 28.7986 20.1811 28.8907 19.8652 28.8907H13.2545C12.792 28.8907 12.352 29.0748 12.0361 29.4084L11.1675 30.2942"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.4912 23.7619L2.12207 26.1779L9.70806 33.914L12.0772 31.498L4.4912 23.7619Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M33.3009 21.2058H3.55264C2.17635 21.2058 1.0708 20.0669 1.0708 18.6749V17.4669H35.7827V18.6749C35.7827 20.0669 34.6659 21.2058 33.3009 21.2058Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.0095 15.7873C12.7229 15.7873 14.1118 14.3708 14.1118 12.6236C14.1118 10.8763 12.7229 9.4599 11.0095 9.4599C9.29617 9.4599 7.90723 10.8763 7.90723 12.6236C7.90723 14.3708 9.29617 15.7873 11.0095 15.7873Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M25.4041 15.7873C27.1174 15.7873 28.5064 14.3708 28.5064 12.6236C28.5064 10.8763 27.1174 9.4599 25.4041 9.4599C23.6907 9.4599 22.3018 10.8763 22.3018 12.6236C22.3018 14.3708 23.6907 15.7873 25.4041 15.7873Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.35821 14.2457H4.59033V9.40242C4.59033 8.05641 5.66203 6.9635 6.98192 6.9635H7.61366H28.5965H29.2395C30.5481 6.9635 31.6085 8.05641 31.6085 9.40242V14.2457H28.055"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M22.7419 14.2457H13.6719"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M28.6079 6.96348H7.60254L12.8144 1.63697C13.2092 1.18831 13.7733 0.923706 14.3599 0.923706H21.8393C22.4259 0.923706 22.9899 1.1768 23.3848 1.63697L28.6079 6.96348Z"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.4512 0.935242V6.4113"
                        stroke="#A2A8B8"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /></svg
                  ></span>
                  <p>Demo</p>
                  <h5>{{ leadsCounts[5] }}</h5>
                  <img
                    class="img-fluid"
                    src="../../assets/img/shadow.svg"
                    alt=""
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-4">
        <!-- <div class="sale-timeline">
                    <div class="timeline">
                        <button type="button" v-bind:class="filters_.duration == 'today' ? 'current': '' " v-on:click="updateGraphs('today')" ><span class="today">Today</span></button>
                        <button type="button" v-bind:class="filters_.duration == 'monthly' ? 'current': '' " v-on:click="updateGraphs('monthly')" ><span class="today">This Month</span></button>
                        <button type="button" v-bind:class="filters_.duration == 'custom' ? 'current': '' "><date-range-picker :opens="'left'" :ranges="false" :locale-data="{ format: 'yyyy-mm-dd' }"  v-model="filters_.customDate" @update="updateGraphs('custom')"></date-range-picker><span class="month">Custom Day</span></button>
                    </div>
                </div> -->

        <!-- sale-sold -->
        <div class="sale-sold">
          <div class="title-grap">
            <h4>Sold</h4>
          </div>
          <div class="salesold-list">
            <ul>
              <li>
                <a @click="sold('new')"
                  >New <span class="list1">{{ soldCounts[1] }}</span></a
                >
              </li>
              <li>
                <a @click="sold('used')"
                  >Used <span class="list3">{{ soldCounts[0] }}</span></a
                >
              </li>
              <li>
                <a @click="sold('')">
                  Purchased 
                  <span class="list2">
                    <template v-if="leadsCounts[6]">
                      {{ leadsCounts[6] }}
                    </template>
                    <template v-else>
                      0
                    </template>
                  </span>
                </a>
              </li>
              <!-- <li>
                <a @click="sold">Leased <span class="list4">0</span></a>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- sale-sold -->
      </div>
    </div>
  </div>
  <!-- <div>
      <div class="download-search">
          <div class="row">
              <div class="col-sm-8">
                  <div class="perfor-search">
                      <div class="form-row">
                          <div class="form-group col-md-5">
                              <autocomplete
                                  ref="autocomplete"
                                  placeholder="Search by Agent or Team"
                                  input-class="form-control"
                                  :source="base_url+'search_agent_or_team/'"
                                  results-property="data"
                                  :results-display=formattedAutocompleteDisplay
                                  :request-headers="autocompleteAuthHeaders"
                                  @selected="getLeadsCounts">
                              </autocomplete>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-md-8">
              <div class="active-tabss dashboard-active-tabs">
                  <div class="tl">
                      <ul class="tl_btns tl_btns_dashboard">
                          <li id="tab1">
                              <router-link :to="{path:'/leads',query:{status:'1'}}">
                                  <span><svg xmlns="http://www.w3.org/2000/svg" width="27" height="19" viewBox="0 0 27 19" fill="none">
                                  <g clip-path="url(#clip0)">
                                  <path d="M1.44727 10.2649L8.85779 17.6402L25.5315 1.0459" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                  </g>
                                  <defs>
                                  <clipPath id="clip0">
                                  <rect x="0.773438" y="0.0400391" width="25.6" height="18.7733" fill="white"/>
                                  </clipPath>
                                  </defs>
                                  </svg></span><p>Active</p><p class="counterInt">{{leadsCounts[1]}}</p>
                              </router-link>
                          </li>
                          <li id="tab2"><router-link :to="{path:'/leads',query:{status:'2'}}"><span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="25" viewBox="0 0 40 25" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.2036 1.3987C25.354 0.877949 24.3506 0.642932 23.3563 0.753339L23.356 0.753371L21.1313 0.997843L21.1281 0.998207C19.9502 1.13517 18.8645 1.72393 18.12 2.65911L13.8321 7.82648L13.8317 7.82698C13.3803 8.36935 13.5568 9.20892 14.2175 9.5067C15.989 10.3174 18.0567 10.0731 19.5962 8.88474L19.5962 8.88468L21.7972 7.18507L21.7973 7.18519L21.8069 7.17739C21.8074 7.17694 21.8075 7.17693 21.8079 7.1768C21.8085 7.17659 21.8108 7.17596 21.815 7.17606C21.8241 7.1763 21.8369 7.17994 21.8488 7.18962L21.8511 7.19146L22.7192 7.88842C22.9345 8.06129 23.2492 8.02687 23.4221 7.81154C23.595 7.5962 23.5606 7.2815 23.3452 7.10862L22.4794 6.4135L22.478 6.41241C22.1177 6.12068 21.5771 6.08017 21.1819 6.39675L18.9851 8.09315L18.985 8.0932C17.7371 9.05647 16.064 9.25255 14.6323 8.59682L14.6286 8.59515C14.582 8.57426 14.5637 8.51064 14.6004 8.46667L14.601 8.46586L18.8929 3.29366L18.8929 3.29374L18.8996 3.28532C19.4752 2.56048 20.3193 2.09939 21.2421 1.99169L21.2436 1.99151L23.4659 1.74732L23.4665 1.74725C24.2313 1.66227 25.0114 1.84209 25.677 2.24883L30.6758 5.44898L30.6758 5.45657V17.684C30.6758 18.6326 31.4499 19.4067 32.3985 19.4067H38.8791C39.1552 19.4067 39.3791 19.1829 39.3791 18.9067V4.23383C39.3791 3.95769 39.1552 3.73383 38.8791 3.73383H32.3985C31.8189 3.73383 31.3045 4.0228 30.9919 4.464L26.2119 1.4039L26.212 1.40382L26.2036 1.3987ZM14.9684 4.38495C15.2072 4.24626 15.2883 3.94025 15.1496 3.70146C15.011 3.46268 14.7049 3.38153 14.4662 3.52022L12.1616 4.85874H10.6211C10.345 4.85874 10.1211 5.08259 10.1211 5.35874C10.1211 5.63488 10.345 5.85874 10.6211 5.85874H12.2963C12.3845 5.85874 12.4711 5.8354 12.5474 5.7911L14.9684 4.38495ZM0.558105 3.73383C0.281963 3.73383 0.0581055 3.95769 0.0581055 4.23383V18.9067C0.0581055 19.1829 0.281963 19.4067 0.558105 19.4067H7.03864C7.98729 19.4067 8.76138 18.6326 8.76138 17.684V17.4014H10.3396L13.7151 22.9687L13.716 22.9702C14.4795 24.2196 15.8396 24.9824 17.3095 24.9824C18.1632 24.9824 18.7902 24.3435 18.9037 23.609C19.379 23.7442 19.8429 23.7969 20.2924 23.7578C21.0052 23.6959 21.6448 23.406 22.2008 22.9138C22.4272 22.7161 22.578 22.4658 22.6562 22.1968C23.1533 22.3455 23.6382 22.4047 24.1073 22.3639C24.8201 22.3019 25.4598 22.0121 26.0158 21.5199C26.1935 21.3646 26.3247 21.1769 26.4107 20.9732C27.4407 21.14 28.3705 20.8748 29.1603 20.1607C29.7317 19.6595 29.8193 18.8229 29.4729 18.1992L29.4729 18.1992L29.4694 18.1931L28.3811 16.2978C28.2436 16.0584 27.938 15.9757 27.6986 16.1132C27.4591 16.2507 27.3764 16.5563 27.5139 16.7958L28.6002 18.6875C28.7401 18.9423 28.6821 19.2511 28.4995 19.41L28.4995 19.41L28.4922 19.4166C27.9249 19.9307 27.2779 20.122 26.4909 19.9723C26.4569 19.8277 26.4033 19.6874 26.3306 19.5565L26.3306 19.5565L26.3274 19.5508L24.1142 15.687C23.977 15.4474 23.6715 15.3644 23.4319 15.5016C23.1922 15.6389 23.1092 15.9444 23.2465 16.184L25.4578 20.0446C25.5023 20.1256 25.5268 20.212 25.5337 20.2974C25.5268 20.3412 25.526 20.3849 25.5306 20.4275C25.5131 20.5621 25.4519 20.6849 25.3573 20.7673L25.3573 20.7673L25.3541 20.7701C24.9444 21.1331 24.5025 21.3258 24.0207 21.3677C23.6041 21.4039 23.1313 21.3295 22.5965 21.1184C22.5729 21.061 22.5459 21.0049 22.5157 20.9505L22.5157 20.9504L22.5125 20.9448L20.2993 17.0809C20.162 16.8413 19.8565 16.7583 19.6169 16.8955C19.3773 17.0328 19.2943 17.3383 19.4316 17.5779L21.6081 21.3779C21.5874 21.5198 21.6292 21.6634 21.72 21.7717C21.7126 21.9255 21.6486 22.0687 21.5423 22.1613L21.5423 22.1612L21.5391 22.1641C21.1295 22.527 20.6876 22.7197 20.2057 22.7616C19.7545 22.8008 19.2374 22.7102 18.6468 22.4568L16.6 18.669C16.4687 18.4261 16.1654 18.3356 15.9224 18.4668C15.6795 18.5981 15.589 18.9015 15.7203 19.1444L17.8478 23.0817L17.8477 23.0817L17.8536 23.092C17.9008 23.1746 17.9222 23.2692 17.9222 23.3697C17.9222 23.69 17.6602 23.9824 17.3095 23.9824C16.1875 23.9824 15.1513 23.4006 14.5697 22.4495L14.5693 22.4487L11.0487 16.6422C10.958 16.4927 10.7959 16.4014 10.6211 16.4014H8.76138V5.45657C8.76138 4.50792 7.98729 3.73383 7.03864 3.73383H0.558105ZM7.76123 16.9014L7.76138 16.8891V5.45657C7.76138 5.06021 7.435 4.73383 7.03864 4.73383H1.05811V18.4067H7.03864C7.435 18.4067 7.76138 18.0804 7.76138 17.684V16.9138L7.76123 16.9014ZM4.74 14.9328C4.74 15.2975 4.44438 15.5931 4.07971 15.5931C3.71505 15.5931 3.41943 15.2975 3.41943 14.9328C3.41943 14.5681 3.71505 14.2725 4.07971 14.2725C4.44438 14.2725 4.74 14.5681 4.74 14.9328ZM32.3985 4.73383C32.0022 4.73383 31.6758 5.06021 31.6758 5.45657V17.684C31.6758 18.0804 32.0022 18.4067 32.3985 18.4067H38.3791V4.73383H32.3985ZM36.0173 14.9328C36.0173 15.2975 35.7217 15.5931 35.3571 15.5931C34.9924 15.5931 34.6968 15.2975 34.6968 14.9328C34.6968 14.5681 34.9924 14.2725 35.3571 14.2725C35.7217 14.2725 36.0173 14.5681 36.0173 14.9328ZM27.214 15.5931C27.5786 15.5931 27.8743 15.2975 27.8743 14.9328C27.8743 14.5681 27.5786 14.2725 27.214 14.2725C26.8493 14.2725 26.5537 14.5681 26.5537 14.9328C26.5537 15.2975 26.8493 15.5931 27.214 15.5931ZM24.0863 8.65003C24.335 8.52996 24.6339 8.6342 24.754 8.88287L26.6492 12.8079C26.7693 13.0565 26.665 13.3555 26.4164 13.4755C26.1677 13.5956 25.8688 13.4914 25.7487 13.2427L23.8535 9.3177C23.7334 9.06903 23.8376 8.77011 24.0863 8.65003Z" fill="#A2A8B8"/>
                          </svg></span><p>Contacted</p><p class="counterInt">{{leadsCounts[2]}}</p></router-link></li>
                          <li id="tab3"><router-link :to="{path:'/leads',query:{status:'3'}}"><span><svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
                              <path d="M15.8407 27.9259H2.55906C1.94573 27.9259 1.44873 27.4196 1.44873 26.795V4.55382C1.44873 3.92913 1.94573 3.42291 2.55906 3.42291H26.3518C26.9651 3.42291 27.4621 3.92913 27.4621 4.55382V16.9076" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M20.8213 0.751831V5.06004" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M27.4621 8.40967H1.44873" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M8.95687 17.1015H5.25578C4.95969 17.1015 4.72705 16.8646 4.72705 16.563V14.3227C4.72705 14.0211 4.95969 13.7842 5.25578 13.7842H8.95687C9.25295 13.7842 9.48559 14.0211 9.48559 14.3227V16.563C9.48559 16.8538 9.25295 17.1015 8.95687 17.1015Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M16.306 17.1015H12.6049C12.3088 17.1015 12.0762 16.8646 12.0762 16.563V14.3227C12.0762 14.0211 12.3088 13.7842 12.6049 13.7842H16.306C16.6021 13.7842 16.8347 14.0211 16.8347 14.3227V16.563C16.8347 16.8538 16.6021 17.1015 16.306 17.1015Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M19.4253 16.1752V14.3227C19.4253 14.0211 19.6579 13.7842 19.954 13.7842H23.6445C23.9406 13.7842 24.1733 14.0211 24.1733 14.3227V15.5398" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M8.95687 23.6931H5.25578C4.95969 23.6931 4.72705 23.4561 4.72705 23.1545V20.9143C4.72705 20.6127 4.95969 20.3757 5.25578 20.3757H8.95687C9.25295 20.3757 9.48559 20.6127 9.48559 20.9143V23.1545C9.48559 23.4453 9.25295 23.6931 8.95687 23.6931Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M14.6881 23.6931H12.6049C12.3194 23.6931 12.0762 23.4561 12.0762 23.1545V20.9143C12.0762 20.6235 12.3194 20.3757 12.6049 20.3757H15.3649" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M28.403 22.3683C28.4981 22.7883 28.551 23.2407 28.551 23.693C28.551 26.9242 25.9814 29.5414 22.8196 29.5414C19.6472 29.5414 17.0776 26.9242 17.0776 23.693C17.0776 20.4726 19.6472 17.8554 22.8196 17.8554C23.9617 17.8554 25.0297 18.2001 25.9285 18.8032" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M21.1489 23.5207L22.714 25.1148L28.5511 19.1694" fill="white"/>
                              <path d="M21.1489 23.5207L22.714 25.1148L28.5511 19.1694" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M7.5293 0.751831V5.06004" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg></span><p>Scheduled</p><p class="counterInt">{{leadsCounts[3]}}</p></router-link>
                          </li>
                          <li id="tab4">
                              <router-link :to="{path:'/leads',query:{status:'4'}}">
                              <span><svg xmlns="http://www.w3.org/2000/svg" width="34" height="47" viewBox="0 0 34 47" fill="none">
                              <path d="M18.3125 9.40841C20.595 9.40841 22.4454 7.52612 22.4454 5.2042C22.4454 2.88229 20.595 1 18.3125 1C16.03 1 14.1797 2.88229 14.1797 5.2042C14.1797 7.52612 16.03 9.40841 18.3125 9.40841Z" stroke="#A2A8B8" stroke-miterlimit="10"/>
                              <path d="M16.6154 10.9098C12.4678 11.9008 8.54894 13.1696 5.84783 14.3633C5.35337 14.581 4.94746 14.9639 4.70392 15.4519L1.16886 22.5465C0.807241 23.2747 1.0434 24.1606 1.71499 24.596C2.49728 25.1065 3.53787 24.8062 3.95115 23.9579L7.16886 17.2912L11.6264 15.8498C11.7297 15.8198 11.8405 15.8198 11.929 15.8648C12.0914 15.9474 12.1726 16.1201 12.143 16.2927L8.822 34.8813C8.75558 35.2567 8.59322 35.6095 8.35706 35.9098L2.9327 42.6516C2.42348 43.2822 2.3792 44.1831 2.82938 44.8588C3.49359 45.8723 4.92532 45.9774 5.72237 45.0615L11.8035 38.087C12.1061 37.7417 12.298 37.3137 12.3497 36.8558L13.0286 31.06C13.0803 30.5945 13.619 30.3768 13.9733 30.6771L18.1947 34.2582C18.6523 34.6411 18.9327 35.1966 18.9844 35.7972L19.6928 44.063C19.7814 45.1216 20.7556 45.8648 21.7814 45.6621C22.6301 45.4894 23.2353 44.7161 23.1984 43.8378L22.7777 34.2207C22.7556 33.6201 22.4973 33.0495 22.0619 32.6366C22.0619 32.6366 16.3423 28.1996 16.8441 27.569C18.3202 25.6921 18.7334 19.6336 18.7334 19.6336C18.8294 19.2657 19.3091 19.1831 19.5157 19.4984L21.8847 22.9969C22.2464 23.5225 22.8072 23.8753 23.4272 23.9579L31.0139 24.9489C31.9142 25.069 32.7039 24.3558 32.7039 23.4324C32.7039 22.6966 32.1873 22.066 31.4788 21.9309L24.6523 20.6396C24.1283 20.542 23.6633 20.2116 23.4124 19.7387C21.191 15.4894 19.1246 10.3092 16.6154 10.9098Z" stroke="#A2A8B8" stroke-miterlimit="10"/>
                              </svg></span><p>Visit</p><p class="counterInt">{{leadsCounts[4]}}</p></router-link>
                          </li>
                          <li id="tab5"><router-link :to="{path:'/leads',query:{status:'5'}}"><span><svg xmlns="http://www.w3.org/2000/svg" width="37" height="35" viewBox="0 0 37 35" fill="none">
                          <path d="M8.66294 21.1944L5.53809 24.4386" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M3.94727 21.1944H8.65148H17.2138C18.0712 21.1944 18.7819 21.9077 18.7819 22.805V23.6908C18.7819 24.5652 18.0825 25.2899 17.2138 25.2899H13.7957" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13.796 25.3013H18.974C19.3011 25.3013 19.617 25.2093 19.8878 25.0367L24.4453 22.1261C25.235 21.62 26.2841 21.85 26.8031 22.6438C27.3333 23.4721 27.1077 24.5766 26.2841 25.1058L20.779 28.6261C20.5082 28.7986 20.1811 28.8907 19.8652 28.8907H13.2545C12.792 28.8907 12.352 29.0748 12.0361 29.4084L11.1675 30.2942" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M4.4912 23.7619L2.12207 26.1779L9.70806 33.914L12.0772 31.498L4.4912 23.7619Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M33.3009 21.2058H3.55264C2.17635 21.2058 1.0708 20.0669 1.0708 18.6749V17.4669H35.7827V18.6749C35.7827 20.0669 34.6659 21.2058 33.3009 21.2058Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M11.0095 15.7873C12.7229 15.7873 14.1118 14.3708 14.1118 12.6236C14.1118 10.8763 12.7229 9.4599 11.0095 9.4599C9.29617 9.4599 7.90723 10.8763 7.90723 12.6236C7.90723 14.3708 9.29617 15.7873 11.0095 15.7873Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M25.4041 15.7873C27.1174 15.7873 28.5064 14.3708 28.5064 12.6236C28.5064 10.8763 27.1174 9.4599 25.4041 9.4599C23.6907 9.4599 22.3018 10.8763 22.3018 12.6236C22.3018 14.3708 23.6907 15.7873 25.4041 15.7873Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8.35821 14.2457H4.59033V9.40242C4.59033 8.05641 5.66203 6.9635 6.98192 6.9635H7.61366H28.5965H29.2395C30.5481 6.9635 31.6085 8.05641 31.6085 9.40242V14.2457H28.055" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M22.7419 14.2457H13.6719" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M28.6079 6.96348H7.60254L12.8144 1.63697C13.2092 1.18831 13.7733 0.923706 14.3599 0.923706H21.8393C22.4259 0.923706 22.9899 1.1768 23.3848 1.63697L28.6079 6.96348Z" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M17.4512 0.935242V6.4113" stroke="#A2A8B8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg></span><p>Demo</p><p class="counterInt">{{leadsCounts[5]}}</p></router-link></li>
                      </ul>
                  </div>
              </div>
          </div>
          <div class="col-md-4">
              <div class="graph-area sold-section">
                  <div class="grap-title">
                      <div class="title-grap">
                          <h4>Sold</h4>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-5 sold-sec-content">
                          <div>New<span class="purple">{{soldCounts[1]}}</span></div>
                      </div>
                      <div class="col-6 sold-sec-content">
                          <div>Purchased<span class="blue">{{leadsCounts[6]}}</span></div>
                      </div>
                      <div class="col-5 sold-sec-content">
                          <div>Used<span class="yellow">{{soldCounts[0]}}</span></div>
                      </div>
                      <div class="col-6 sold-sec-content">
                          <div>leased<span class="green">0</span></div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div> -->
</template>
<script>
import axios from "axios";
//import Autocomplete from 'vuejs-auto-complete'
import moment from "moment";
import $ from "jquery";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import SingleSelect from "../helpers/singleSelect";

export default {
  name: "CounterTabs",
  components: { DateRangePicker, SingleSelect },
  data() {
    return {
      agent: {
        id : "",
        text : "Select Agent",
      },
      allEmployees: [],
      leadsCounts: [0, 0, 0, 0, 0, 0, 0],
      soldCounts: [0, 0],
      filters_: {
        duration: "monthly",
        customDate: {},
        id: 0,
        tm_id: 0,
        from: "",
        to: "",
      },
      base_url: axios.defaults.baseURL,
      todayStats: { appt: 0, tasks: 0, alerts: 0, leads: 0 },
    };
  },
  created() {
    this.getAllEmployees();
    this.getTodayStats();
    
    if (this.$route.name == "myReports") {
      this.myReports();
    } else {
      this.getLeadsCounts();
    }
    let vm = this;
    this.$root.$on("action", function (action, data) {
      if (action == "update_dashboard") {
        vm.getSoldCounts();
        vm.getLeadsCounts();
      }
      if (action == "activitygraph") {
        if (data.index == 0) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "leads?type=1&filter=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push("leads?type=1&filter=" + vm.filters_.duration);
          }
        } else if (data.index == 1) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "leads?type=2&filter=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push("leads?type=2&filter=" + vm.filters_.duration);
          }
        } else if (data.index == 2) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "leads?type=3&filter=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push("leads?type=3&filter=" + vm.filters_.duration);
          }
        }
      } else if (action == "appointmentgraph") {
        if (data.index == 0) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "appointments?type=created&duration=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push(
              "appointments?type=created&duration=" + vm.filters_.duration
            );
          }
        }

        if (data.index == 1) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "appointments?type=scheduled&duration=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push(
              "appointments?type=scheduled&duration=" + vm.filters_.duration
            );
          }
        }

        if (data.index == 2) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "appointments?type=confirmed&duration=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push(
              "appointments?type=confirmed&duration=" + vm.filters_.duration
            );
          }
        }

        if (data.index == 3) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "appointments?type=missed&duration=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push(
              "appointments?type=missed&duration=" + vm.filters_.duration
            );
          }
        }

        if (data.index == 4) {
          if (vm.filters_.duration == "custom") {
            vm.$router.push(
              "appointments?type=shown&duration=" +
                vm.filters_.duration +
                "&from=" +
                vm.filters_.from +
                "&to=" +
                vm.filters_.to
            );
          } else {
            vm.$router.push(
              "appointments?type=shown&duration=" + vm.filters_.duration
            );
          }
        }
      } else if (action == "activity") {
        if (vm.filters_.duration == "custom") {
          vm.$router.push(
            "/reports/user-activity-report?duration=" +
              vm.filters_.duration +
              "&from=" +
              vm.filters_.from +
              "&to=" +
              vm.filters_.to
          );
        } else {
          vm.$router.push(
            "/reports/user-activity-report?duration=" + vm.filters_.duration
          );
        }
      }
    });
  },
  methods: {
    goToLeadsheet(status) {
      if (this.filters_.duration == "custom") {
        this.$router.push(
          "leads?status=" +
            status +
            "&filter=" +
            this.filters_.duration +
            "&from=" +
            this.filters_.from +
            "&to=" +
            this.filters_.to
        );
      } else {
        this.$router.push(
          "leads?status=" + status + "&filter=" + this.filters_.duration
        );
      }
    },
    sold(cat) {
      if (this.filters_.duration == "custom") {
        this.$router.push(
          "leads?type=sold&source=" +
            cat +
            "&filter=" +
            this.filters_.duration +
            "&from=" +
            this.filters_.from +
            "&to=" +
            this.filters_.to
        );
      } else {
        this.$router.push(
          "leads?type=sold&source=" + cat + "&filter=" + this.filters_.duration
        );
      }
    },
    getAllEmployees() {
      axios
        .get("all_employees", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {

            if (res.data.success.length > 0) {
              var dd = [{
                id : "",
                text : "All",
              }];
              $.each(res.data.success, function (key, value) {
                dd.push({
                  id: value.id,
                  text: value.name,
                });
              });
              this.allEmployees = dd;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateGraphs(dur) {
      this.filters_.duration = dur;
      if (dur == "custom") {
        let startDate = this.filters_.customDate.startDate;
        let endDate = this.filters_.customDate.endDate;
        if (
          startDate != undefined &&
          startDate != "undefined" &&
          startDate != null &&
          startDate != ""
        ) {
          this.filters_.from = moment(new Date(startDate)).format("YYYY-MM-DD");
        }
        if (
          endDate != undefined &&
          endDate != "undefined" &&
          endDate != null &&
          endDate != ""
        ) {
          this.filters_.to = moment(new Date(endDate)).format("YYYY-MM-DD");
        }
        //this.getLeadsCounts()
        this.$root.$emit("action", "update_dashboard", this.filters_);
      } else {
        //this.getLeadsCounts()
        this.$root.$emit("action", "update_dashboard", this.filters_);
      }
    },
    myReports() {
      axios
        .get("user", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.id) {
            this.filters_.id = res.data.id;
            this.getLeadsCounts();
            this.$root.$emit("action", "update_dashboard", this.filters_);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSoldCounts() {
      axios
        .post("sold_counter", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.soldCounts = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLeadsCounts(result = "") {
      this.filters_.id = this.agent.id;
      if (result == "update_graph") {
        this.$root.$emit("action", "update_dashboard", this.filters_);
      } else if (result.selectedObject) {
        if (
          result.selectedObject.user != undefined &&
          result.selectedObject.user != "undefined" &&
          result.selectedObject.user != null &&
          result.selectedObject.user != ""
        ) {
          this.filters_.id = result.selectedObject.id;
          this.filters_.tm_id = 0;
        }
        if (
          result.selectedObject.team != undefined &&
          result.selectedObject.team != "undefined" &&
          result.selectedObject.team != null &&
          result.selectedObject.team != ""
        ) {
          this.filters_.id = 0;
          this.filters_.tm_id = result.selectedObject.id;
        }
        this.$root.$emit("action", "update_dashboard", this.filters_);
      }
      //console.log(this.filters_)

      axios
        .post("lead_counter", this.filters_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          this.getSoldCounts();
          if (res.data.success) {
            this.leadsCounts = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formattedAutocompleteDisplay(result) {
      return result.text;
    },
    getTodayStats() {
      axios
        .post(
          "today_stats",
          { duration: "today" },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.todayStats = res.data.success;
          } else {
            this.todayStats = { appt: 0, tasks: 0, alerts: 0, leads: 0 };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    autocompleteAuthHeaders() {
      return { Authorization: "Bearer " + this.$storage.get("auth").token };
    },
  },
};
</script>
<style scoped>
.calender .daterangepicker.opensleft {
  right: -56px !important;
}
.total-heading .media-body h5 {
  font-style: normal;
  font-weight: 400;
  font-size: 16px !important;
  line-height: 1.5;
  color: #6d778e;
}
.vue-daterange-picker {
  min-width: auto;
}
.sourceby .customMS {
  width: 100%;
  margin-left: 15px;
}
.sourceby .customMS-drop h4 {
  border-radius: 30px;
  font-size: 12px;
  border: none;
  box-shadow: 0px 4px 8px rgba(49, 81, 161, 0.08);
}
.sourceby .show-options {
  top: 35px !important;
}
.sourceby .customMS-search input {
  margin: 0;
}
</style>